import React from 'react';
import Typography from '@components/typography';
import { useAppSelector } from '@hooks/statehooks';
import { PricingType } from '../../../enums';
import { perMonthPriceInc, perMonthPriceExc } from '../../../constants';

const TotalCost: React.FC = () => {
  const { pricing } = useAppSelector((state) => state.vehiclePrice);
  const vehicleInformation = useAppSelector(
    (state) => state.vehicleInformation
  );

  return (
    <div className="customise-sidebar__total-cost">
      <div className="total-cost__row">
        <div className="total-cost__price">
          <Typography className="price__value" variant="currency" size="3x">
            {pricing && pricing.price.toLocaleString('en-GB')}
          </Typography>
          <Typography className="price__suffix" variant="caption" size="xs">
            {vehicleInformation.pricingType === PricingType.Personal
              ? perMonthPriceInc
              : perMonthPriceExc}
          </Typography>
        </div>
        <div className="total-cost__breakdown">
          <Typography className="price__total" variant="caption" size="rg">
            In total you'll pay&nbsp;
            <Typography
              className="price__total__value"
              variant="currency"
              size="rg"
            >
              {pricing && pricing.total.toLocaleString('en-GB')}
            </Typography>
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default TotalCost;
